import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { citationUpdateRequest } from 'src/common/Scraper';

interface APIResponse<T = any> {
  status: string;
  message: string;
  response: T;
}

type CreateLocationResponse = {
  campaignId: string;
  paymentId: string;
  paymentStatus: string;
  amountCharged: number;
  packageId: string;
  citationsCount: number;
  publishersCount: number;
  uploadedImages: number;
}

type CitationUpdateRequestResponse = APIResponse<{
  status: string;
  message: string;
  response: CreateLocationResponse;
}>;

type CitationUpdateRequestPayload = {
  payload: any;
  campaignId: string;
};

export const useCitationUpdateRequest = (): UseMutationResult<
  CitationUpdateRequestResponse,
  Error,
  CitationUpdateRequestPayload
> => {
  return useMutation<CitationUpdateRequestResponse, Error, CitationUpdateRequestPayload>({
    mutationFn: async ({payload, campaignId}: CitationUpdateRequestPayload): Promise<CitationUpdateRequestResponse> => {
      return citationUpdateRequest(payload, campaignId) as Promise<CitationUpdateRequestResponse>;
    }
  });
};
